@if (isOpen) {
    <form
        [formGroup]="form"
        (submit)="submit()"
    >
        <div class="grid-container">
            <div class="g-12">
                <p>
                    Bitte gib deine Zahlungsdaten ein. Wir buchen den Versicherungsbeitrag ganz unkompliziert von deinem
                    Konto ab.
                    @if (product().orderConfig?.showTenDayFirstPaymentMessage) {
                        <span>
                            Der Erstbeitrag wird innerhalb von zehn Tagen abgebucht und die Folgebeiträge jeweils am
                            Anfang eines Monats.
                        </span>
                    }
                </p>
            </div>
            <div class="g-12 form-control">
                <label
                    for="input-account-holder"
                    appReactiveLabel
                    formControlName="accountHolder"
                    >Kontoinhaber*:</label
                >
                <input
                    id="input-account-holder"
                    type="text"
                    placeholder="Kontoinhaber*"
                    formControlName="accountHolder"
                    [ctrlErrorMessage]="accountHolderErrorMessages"
                    required
                />
            </div>
            <div class="g-12 form-control">
                <label
                    for="input-iban"
                    appReactiveLabel
                    formControlName="iban"
                    >IBAN*:</label
                >
                <input
                    id="input-iban"
                    type="text"
                    placeholder="IBAN*"
                    formControlName="iban"
                    [ctrlErrorMessage]="ibanErrorMessages"
                    required
                />
            </div>
            <div class="g-12 form-control">
                <label
                    for="input-bic"
                    appReactiveLabel
                    formControlName="bic"
                    >{{ bicLabel() }}:</label
                >
                <input
                    id="input-bic"
                    type="text"
                    [placeholder]="bicLabel()"
                    formControlName="bic"
                    [ctrlErrorMessage]="bicErrorMessages"
                    required
                />
            </div>
            <div class="g-12 form-control">
                <label
                    for="input-name-of-bank"
                    appReactiveLabel
                    formControlName="nameOfBank"
                    >Kreditinstitut*:</label
                >
                <input
                    id="input-name-of-bank"
                    type="text"
                    placeholder="Kreditinstitut*"
                    formControlName="nameOfBank"
                    [ctrlErrorMessage]="nameOfBankErrorMessages"
                    required
                />
            </div>
        </div>
        <div class="grid-container">
            <div class="g-12 p-12:t md:p-16:t lg:p-24:t">
                <div class="bg:grey-5 p-12 md:p-16 lg:p-24 br-3 fs:xs">
                    <app-collapsible-checkbox
                        label="Einzugsermächtigung"
                        formControlName="debit"
                    >
                        <p>Ich ermächtige die astra Versicherung AG Zahlungen von meinem Konto einzuziehen.</p>
                        <p>
                            Zugleich weise ich mein Kreditinstitut an, die von der astra Versicherung AG auf mein Konto
                            gezogenen Lastschriften einzulösen. Dieses Mandat bezieht sich auf das hier geschlossene
                            Vertragsverhältnis mit der astra Versicherung AG.
                        </p>
                        <p>
                            Hinweis: Ich kann innerhalb von acht Wochen, beginnend mit dem Belastungsdatum, die
                            Erstattung des belasteten Betrages verlangen. Es gelten dabei die mit meinem Kreditinstitut
                            vereinbarten Bedingungen. Die Gläubiger&shy;identifikations&shy;nummer der astra
                            Versicherung AG lautet DE45ZZZ00001921408.
                        </p>
                    </app-collapsible-checkbox>
                </div>
            </div>
        </div>
        <app-required-info></app-required-info>
        <app-navigation-buttons
            [nextDisabled]="form.invalid"
            [showBack]="isFirstStep"
            nextTooltip="Bitte fülle alle erforderlichen Felder aus."
            (prev)="btnPrev()"
            (next)="submit()"
        ></app-navigation-buttons>
    </form>
}
